import { useState } from 'react'
import { AppRoutes } from './routes'
import AppErrorBoundary from '@components/common/AppErrorBoundary'
import { ArkCommandShell } from '@components/shell/ArkCommandShell'
import { TopCommandBand } from '@components/shell/TopCommandBand'
import { SystemRail } from '@components/shell/SystemRail'
import { CommandDeck } from '@components/shell/CommandDeck'
import { IntelligenceRail } from '@components/shell/IntelligenceRail'
import { ProofStatusBar } from '@components/shell/ProofStatusBar'
import { SEOHead } from '@components/common/SEOHead'
import { getSurfaceMeta } from '@/lib/seo'
import { useLocation } from 'react-router-dom'

export default function App() {
  const [railExpanded, setRailExpanded] = useState(false)
  const [intelligenceOpen, setIntelligenceOpen] = useState(false)
  const [activeSurface, setActiveSurface] = useState('portfolio')
  const location = useLocation()

  const surfaceFromPath = location.pathname.split('/')[1] || 'portfolio'
  const seoMeta = getSurfaceMeta(surfaceFromPath, location.pathname)

  return (
    <>
      <SEOHead meta={seoMeta} />
      <AppErrorBoundary>
        <ArkCommandShell>
          <TopCommandBand
            activeSurface={activeSurface}
            onToggleIntelligence={() => setIntelligenceOpen(!intelligenceOpen)}
          />
          <div className="flex flex-1 overflow-hidden">
            <SystemRail
              expanded={railExpanded}
              onToggle={() => setRailExpanded(!railExpanded)}
              activeSurface={activeSurface}
              onSurfaceChange={setActiveSurface}
            />
            <CommandDeck
              intelligenceOpen={intelligenceOpen}
            >
              <AppRoutes />
            </CommandDeck>
            <IntelligenceRail
              open={intelligenceOpen}
              onClose={() => setIntelligenceOpen(false)}
            />
          </div>
          <ProofStatusBar />
        </ArkCommandShell>
      </AppErrorBoundary>
    </>
  )
}
